import { ofType } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";
import { of, forkJoin } from "rxjs";
import {
  GET_RAFFLE_SLOTS,
  getRaffleSlotsSuccessAction,
  getRaffleSlotsErrorAction,
  UPDATE_RAFFLE_WINNERS,
  updateRaffleWinnersSuccessAction,
  updateRaffleWinnersErrorAction,
} from "store/actions";

export const fetchRaffleSlotsForEvent = (action$, _, { request, url }) =>
  action$.pipe(
    ofType(GET_RAFFLE_SLOTS),
    switchMap(({ payload }) =>
      forkJoin([
        request(`${url}/editors/${payload}`),
        request(`${url}/events/${payload}/raffle`),
      ]).pipe(
        map((response) => getRaffleSlotsSuccessAction(response)),
        catchError((err) => of(getRaffleSlotsErrorAction(err)))
      )
    )
  );

export const updateRaffleSlotsSelection = (action$, _, { request, url }) =>
  action$.pipe(
    ofType(UPDATE_RAFFLE_WINNERS),
    switchMap(({ payload }) => {
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: payload.slots,
      };
      return request(`${url}/events/${payload.id}/winners`, options).pipe(
        map((response) => updateRaffleWinnersSuccessAction(response)),
        catchError((err) => of(updateRaffleWinnersErrorAction(err)))
      );
    })
  );
